import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription, forkJoin } from "rxjs";
import { EmitterService } from "src/app/EmitterService";
import { AppService } from "src/app/app.service";
import { ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: "app-home-main",
  templateUrl: "./home-demo-one.component.html",
  styleUrls: ["./home-demo-one.component.scss"],
})
export class HomeDemoOneComponent implements OnInit, OnDestroy {
  // Content Toggle
  showFullContent = false;

  // Image Slider
  images1 = [
    { src: "assets/img/school/slide/1.jpg", alt: "Image 01" },
    { src: "assets/img/school/slide/3.jpg", alt: "Image 03" },

  ];
  images2 = [
    { src: "assets/img/school/slide1/7.jpg", alt: "Image 07" },
    { src: "assets/img/school/slide1/5.jpg", alt: "Image 05" },


  ];


  Video = [
    {
      VideoPath: "assets/img/school/video.mp4",

    },



  ]


  @ViewChild('pdTrack') pdTrack!: ElementRef;

  founders = [
    { name: 'Syed Ahmad Shah Sirikoti (R.A)', image: 'assets/img/blog-image/1_Syed_Ahmad_Shah_Sirikoti_(R.A).png' },
    { name: 'Syed Tayyab Shah (R.A)', image: 'assets/img/blog-image/2_Syed_Tayyab_Shah_(R.A).jpeg' },

    { name: 'Syed Taher Shah (M.J.A)', image: 'assets/img/blog-image/3_Syed_Taher_Shah_(M.J.A) .jpg' },
    { name: 'Syed Sabir Shah (M.J.A)', image: 'assets/img/blog-image/4_Syed_Sabir_Shah_(M.J.A).jpeg' },

  ];

  faculties = [
    { name: 'হিফজ বিভাগ', image: 'assets/img/school/faculties/1.png', link: '/hefz' },
    { name: 'ইবতেদায়ী', image: 'assets/img/school/faculties/2.png', link: '/ebtedayee' },
    { name: 'দাখিল (সাধারণ ও বিজ্ঞান)', image: 'assets/img/school/faculties/3.png', link: '/dakhil-general-and-science' },
    { name: 'কারিগরি শিক্ষা', image: 'assets/img/school/faculties/4.png', link: '/karigori-shiksha' }
  ];

  pdCurrent = 0;
  private pdInterval: any;

  pdGoTo(index: number) {
    this.pdCurrent = (index + this.founders.length) % this.founders.length;
    this.pdTrack.nativeElement.style.transform = `translateX(-${this.pdCurrent * 100}%)`;
  }

  movePd(dir: number) {
    this.pdGoTo(this.pdCurrent + dir);
  }

  // Notice Board
  Notices: any[] = [];
  filteredNotices: any[] = [];
  selectedCategory: string = 'all';
  noticeCategories = ['all', 'Karigari', 'Dhakil', 'Ibtedayi', 'Administrative'];

  // Other Data
  subscription: Subscription;
  slides: any[] = [];
  ContentData: any;
  loadingData = true;
  HomeContent: any;
  News_event_data: any;
  mission_data: any;
  vission_data: any;
  MainData: any;
  numVisibleCards: number;
  items = ["photos", "videos"];
  selectedItem = "photos";
  VideoAlbums: any;
  VideoAlbumShown: any[] = [];
  imageLoaded = false;
  ImageAlbums: any;
  ImageAlbumShown: any[] = [];
  GBMessages: any;
  GBMessageShown = [];
  // GBMessageShown: any[] = [];
  foundnews: any;
  foundAchivements: any;
  randomBackgroundColor = "#000000";
  hoverShadowColor = "#00000033";
  all_achievement_data: any;
  isSmall: boolean;
  isBig = true;
  gbExpanded = false;
  principalExpanded = false;
  vpExpanded = false;

  // Modal State
  showMessageModal = false;
  selectedMessage: any = null;

  homepageLatestVideoUrl: string | null = null;

  convertToEmbedUrl(url: string): string {
    const videoRegex = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?)(.*)(?:v=)([a-zA-Z0-9_-]{11})(&|$)/;
    const match = url?.match(videoRegex);
    if (match) {
      const videoId = match[2];
      return `https://www.youtube.com/embed/${videoId}`;
    } else {
      return url || '';
    }
  }

  getShortText(html: string, limit: number): string {
    if (!html) return '';
    const text = html.replace(/<[^>]*>/g, '');
    return text.length > limit ? text.substring(0, limit) + '...' : text;
  }

  constructor(
    private emitterService: EmitterService,
    private appService: AppService,
    private router: Router
  ) {
    this.subscription = this.emitterService.currentMessage.subscribe(
      (message) => {
        if (message === true) {
          const mainData = localStorage.getItem("mainData");
          if (mainData) {
            this.MainData = JSON.parse(mainData);
          }
        }
      }
    );
  }

  ngOnInit(): void {
    this.pdInterval = setInterval(() => this.movePd(1), 4000);
    this.numVisibleCards = window.innerWidth < 768 ? 1 : 3;
    this.smallScreen();
    this.FetchData();
  }

  ngOnDestroy(): void {
    if (this.pdInterval) {
      clearInterval(this.pdInterval);
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  smallScreen(): void {
    this.isSmall = window.innerWidth < 1200;
    this.isBig = window.innerWidth > 1200;
  }

  // Notice Filtering Functions
  filterNotices(category: string): void {
    this.selectedCategory = category;
    if (category === 'all') {
      this.filteredNotices = this.Notices;
    } else {
      this.filteredNotices = this.Notices.filter(
        notice => notice.NoticeCategoryName === category ||
          (category === 'Karigari' && (notice.NoticeCategoryName === 'Alim' || notice.NoticeCategoryName === 'Karigori' || notice.NoticeCategoryName === 'Technical' || notice.NoticeCategoryName === 'Vocational'))
      );
    }
  }

  getFilteredNotices(category: string): any[] {
    return category === 'all'
      ? this.Notices
      : this.Notices.filter(n => n.NoticeCategoryName === category ||
          (category === 'Karigari' && (n.NoticeCategoryName === 'Alim' || n.NoticeCategoryName === 'Karigori' || n.NoticeCategoryName === 'Technical' || n.NoticeCategoryName === 'Vocational')));
  }

  // Data Fetching
  FetchData(): void {
    forkJoin([
      this.appService.getNotices(),
      this.appService.getContents(),
      this.appService.getVideoAlbums(),
      this.appService.getImageFolders(),
      this.appService.getGBMessages(),
      this.appService.getSlides(),
    ])
      .subscribe((responses: any[]) => {
        // Process Notices
        this.Notices = responses[0].data
          .filter(x => x.ShowScroll && x.IsActive)
          .sort((a, b) => b.Id - a.Id)
          .slice(0, 5);
        this.filteredNotices = this.Notices;

        // Process Content Data
        this.ContentData = responses[1].data;
        if (this.ContentData) {
          this.HomeContent = this.ContentData.filter(x => x.MenuCode == 187);
          this.News_event_data = this.ContentData.filter(x => x.ContentCategoryName == "News And Events");
          this.foundnews = this.News_event_data.slice(0, 3);
          this.all_achievement_data = this.ContentData.filter(x => x.ContentCategoryName == "Achievements");
          this.foundAchivements = this.all_achievement_data.slice(0, 3);
          this.mission_data = this.ContentData.filter(x => x.ContentCategoryName == "Mission");
          this.vission_data = this.ContentData.filter(x => x.ContentCategoryName == "Vision");
        }


        /////

        this.VideoAlbums = responses[2].data;

        if (this.VideoAlbums != null) {
          for (let i = 0; i < Math.min(3, this.VideoAlbums.length); i++) {
            this.VideoAlbumShown.push(this.VideoAlbums[i]);
          }
        }

        this.ImageAlbums = responses[3].data;
        // console.log(this.ImageAlbums, "Noman BHai Image");

        if (this.ImageAlbums != null) {
          for (let i = 0; i < Math.min(3, this.ImageAlbums.length); i++) {
            this.ImageAlbumShown.push(this.ImageAlbums[i]);
          }
        }
        this.GBMessages = responses[4].data;
        console.log("GBMessages API Response:", this.GBMessages);

        // console.log(this.GBMessages, "ijhshfdsfjhjsdbhsdhvbsvs");
        let filteredGBM = this.GBMessages.filter((item) =>
          item.Placement.includes("1")
        );
        this.GBMessageShown = filteredGBM.slice(0, 10);
        console.log(this.GBMessageShown, "GBMessageShown");

        this.slides = responses[5].data;
        if (this.slides && this.slides.length > 0) {
          const midpoint = Math.ceil(this.slides.length / 2);
          this.images1 = this.slides.slice(0, midpoint).map((s: any) => ({ src: s.ImageLink, alt: 'Slide Image' }));
          this.images2 = this.slides.slice(midpoint).map((s: any) => ({ src: s.ImageLink, alt: 'Slide Image' }));
        }


        if (this.VideoAlbums != null) {
          const homepageFolder = this.VideoAlbums.find((album: any) => album.Name === 'Homepage Video');
          if (homepageFolder) {
            this.appService.getVideoAlbumsById(homepageFolder.Id).subscribe((res: any) => {
              const videos = res.data.filter((item: any) => item.IsAlbumFolder === false);
              if (videos && videos.length > 0) {
                const latestVideo = videos.sort((a: any, b: any) => b.Id - a.Id)[0];
                this.homepageLatestVideoUrl = this.convertToEmbedUrl(latestVideo.VideoId);
              }
            });
          }
        }

        this.loadingData = false;
      });
  }

  // Utility Functions
  toggleShowContent(): void {
    this.showFullContent = !this.showFullContent;
  }

  TransformUrl(value: string): string {
    return value.includes("https://") ? value : `https://${value}`;
  }

  onNavigate(url: string): void {
    const MyUrl = url.startsWith("http") ? url : `https://${url}`;
    window.open(MyUrl, "_blank");
  }

  selectItem(item: string): void {
    this.selectedItem = item;
  }

  onImageLoad(): void {
    this.imageLoaded = true;
  }

  truncateText(text: string, maxLength: number): string {
    const plainText = text.replace(/<[^>]*>/g, "");
    return plainText.length > maxLength
      ? plainText.substring(0, maxLength) + "..."
      : text;
  }

  getMessageHref(GBDesignationName: string): string {
    const routes: { [key: string]: string } = {
      "Vice-Principal": "/administration/message-of-vice-principal",
      "Principal": "/administration/message-of-principal",
      "Chairman": "/administration/message-of-chairman",
      "Chief Patron": "/administration/message-of-chief-patron",
      "Secretary General": "/administration/message-of-secretary-general"
    };
    return routes[GBDesignationName] || "#";
  }

  onNavigateMessage(designation: string, item?: any): void {
    if (item) {
      this.selectedMessage = item;
      this.showMessageModal = true;
      return;
    }
    // Find the message with the matching designation
    const message = this.GBMessageShown.find(i => i.GBDesignationName === designation);
    if (message) {
      this.selectedMessage = message;
      this.showMessageModal = true;
    } else {
      console.warn("Message not found for designation:", designation);
    }
  }

  closeMessageModal(): void {
    this.showMessageModal = false;
    this.selectedMessage = null;
  }
}